import React from "react";
import { Skeleton } from "components/skeleton";
import "./refund-item.css";

/** Loading placeholder mirroring a pending RefundItem: card · date · amount · actions. */
function SkeletonRefundItem() {
  return (
    <div className="rf-item">
      <div className="rf-item__row">
        <div className="rf-item__info">
          <Skeleton width={128} height={14} />
          <Skeleton width={72} height={11} />
        </div>
        <Skeleton width={64} height={14} />
        <div className="rf-item__actions">
          <Skeleton width={62} height={30} borderRadius="8px" />
          <Skeleton width={62} height={30} borderRadius="8px" />
        </div>
      </div>
    </div>
  );
}

export default SkeletonRefundItem;
